


import React from "react";

export const ChevronLeftIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-5 h-5 text-gray-50",
    ...props
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className={className} {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M13.7071 16.7071C13.3166 17.0976 12.6834 17.0976 12.2929 16.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289L12.2929 3.29289C12.6834 2.90237 13.3166 2.90237 13.7071 3.29289C14.0976 3.68342 14.0976 4.31658 13.7071 4.70711L8.41421 10L13.7071 15.2929C14.0976 15.6834 14.0976 16.3166 13.7071 16.7071Z" fill="currentColor" />
        </svg>
    );
};